import { graphql } from "../__generated__/gql";

export const GET_COUNTRY_YEAR_QUERY = graphql(`
  query GetCountryYear($countryId: Int, $yearMin: Int, $yearMax: Int) {
    countryYear: countryYear(
      countryId: $countryId
      yearMin: $yearMin
      yearMax: $yearMax
    ) {
      countryId
      year
      population
    }
  }
`);

export default GET_COUNTRY_YEAR_QUERY;
